import LOGO_URL from "../assets/deviDarshanLogo";

/**
 * Phase 36da.99.bp — TopBrandBar (refined)
 *
 * Always-white branding strip pinned to the very top of the app shell.
 * Stays white in BOTH light and dark mode by design — the logo has dark
 * elements that read poorly on a dark background, and keeping the brand
 * surface consistent across themes mirrors how most product UIs handle
 * partner branding.
 *
 * Layout (~46px tall):
 *   ┌─────────────────────────────────────────────────────────────────────┐
 *   │  [LOGO]  │  DEVI DARSHAN              GarmentERP   ·   Powered SMIT │
 *   │          │  Uniforms That Define Authority                          │
 *   ├─────────────────────────────────────────────────────────────────────┤  ← thin red accent stripe
 *
 * No `position: sticky` is needed — the App root is a fixed-height flex
 * column, so the bar is naturally pinned above the scrollable <main>.
 */
export default function TopBrandBar() {
    return (
        <div style={{
            flexShrink: 0,
            background: "linear-gradient(180deg, #FFFFFF 0%, #FCFAF7 100%)",
            borderBottom: "1px solid #E8E2D8",
            boxShadow: "0 1px 0 rgba(0,0,0,0.02), 0 2px 4px rgba(0,0,0,0.03)",
            position: "relative",
        }}>
            <div style={{
                height: 46,
                display: "flex", alignItems: "center",
                padding: "0 18px",
                gap: 16,
            }}>
                {/* Logo block */}
                <div style={{
                    height: 38, display: "flex", alignItems: "center",
                    padding: "0 4px",
                }}>
                    <img src={LOGO_URL} alt="Devi Darshan" style={{
                        height: 34, width: "auto", display: "block",
                        objectFit: "contain", marginTop: 1,
                    }} />
                </div>

                {/* Vertical divider */}
                <div style={{
                    width: 1, height: 28,
                    background: "linear-gradient(180deg, transparent 0%, #D6CFC2 30%, #D6CFC2 70%, transparent 100%)",
                    flexShrink: 0,
                }} />

                {/* Brand text */}
                <div style={{
                    display: "flex", flexDirection: "column",
                    justifyContent: "center", gap: 1,
                    minWidth: 0, flexShrink: 1,
                }}>
                    <span style={{
                        fontSize: 13, fontWeight: 800, color: "#1F2937",
                        letterSpacing: "0.14em", textTransform: "uppercase", lineHeight: 1.1,
                    }}>
                        Devi Darshan
                    </span>
                    <span style={{
                        fontSize: 9.5, fontWeight: 600, color: "#C41040",
                        letterSpacing: "0.18em", textTransform: "uppercase", lineHeight: 1.1,
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                    }}>
                        Uniforms That Define Authority
                    </span>
                </div>

                <div style={{ flex: 1 }} />

                {/* Right cluster */}
                <div style={{
                    display: "flex", alignItems: "center", gap: 14,
                    flexShrink: 0,
                }}>
                    <div style={{
                        display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1,
                    }}>
                        <span style={{
                            fontSize: 12, fontWeight: 700, color: "#374151",
                            letterSpacing: "0.06em", lineHeight: 1.1,
                        }}>
                            GarmentERP
                        </span>
                        <span style={{
                            fontSize: 8.5, fontWeight: 600, color: "#9CA3AF",
                            letterSpacing: "0.14em", textTransform: "uppercase", lineHeight: 1.1,
                        }}>
                            Production Suite
                        </span>
                    </div>

                    <div style={{
                        width: 1, height: 24,
                        background: "linear-gradient(180deg, transparent 0%, #D6CFC2 30%, #D6CFC2 70%, transparent 100%)",
                    }} />

                    <div style={{
                        display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1,
                    }}>
                        <span style={{
                            fontSize: 8.5, fontWeight: 600, color: "#9CA3AF",
                            letterSpacing: "0.10em", textTransform: "uppercase", lineHeight: 1.1,
                        }}>
                            Powered by
                        </span>
                        <span style={{
                            fontSize: 11.5, fontWeight: 800, color: "#1F2937",
                            letterSpacing: "0.06em", lineHeight: 1.1,
                        }}>
                            SMIT Solutions
                        </span>
                    </div>
                </div>
            </div>

            {/* Bottom accent stripe */}
            <div style={{
                height: 2,
                background: "linear-gradient(90deg, #D62828 0%, #C41040 50%, #D62828 100%)",
            }} />
        </div>
    );
}